import type * as React from 'react';

function SvgArrowBackCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M14.0303 7.2197C13.7373 6.9267 13.2626 6.9267 12.9697 7.2197L8.71975 11.4697C8.42675 11.7627 8.42675 12.2373 8.71975 12.5302L12.9697 16.7802C13.1162 16.9267 13.3076 16.9999 13.5 16.9999C13.6924 16.9999 13.8839 16.9267 14.0303 16.7802C14.3233 16.4872 14.3233 16.0126 14.0303 15.7197L10.3107 12L14.0303 8.2803C14.3233 7.9873 14.3233 7.5126 14.0303 7.2197Z"
        fill="currentColor"
      />
      <path
        d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowBackCircle;
